import type {QueryBuilder} from '@albert-io/json-api-framework/request/builder';
import {getUserQuery} from 'client/Clever/util';
import type {CleverUser} from 'client/Clever/util';
import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';
import useAreLatestQueriesReady from 'lib/hooks/useAreLatestQueriesReady';

interface CleverUserResult {
  user: CleverUser | null;
  showClever: boolean;
}

/**
 * The current teacher's Clever profile + whether Clever sync should be offered.
 */
export const useCleverUser = (): CleverUserResult => {
  const isMasquerading = masqueradeStore.isMasquerading();
  const {isReady} = useAreLatestQueriesReady(
    isMasquerading ? [] : [() => getUserQuery() as unknown as QueryBuilder]
  );
  const user =
    !isMasquerading && isReady ? (getUserQuery().getResource() as unknown as CleverUser) : null;
  const showClever = Boolean(user?.getMeta().isAllowCleverSync());

  return {user, showClever};
};
